import { createSlice } from '@reduxjs/toolkit';

const { reducer, actions } = createSlice({
  name: 'available',
  initialState: {
    items: {},
  },
  reducers: {
    update(state, action) {
      action.payload.forEach((item) => state.items[item.imei] = item);
    },
  },
});

export { actions as availableActions };
export { reducer as availableReducer };
